// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__20bm8","sm":"Avatar_sm__3kR+a","md":"Avatar_md__KE3RM","lg":"Avatar_lg__y2Pu-"};